import { DEBOUNCE_TIME_FOR_KEYSTROKE_IN_MS } from 'Lib/Rxjs/constants';
import { debounceAllButFirst, groupByKey, switchMapByKey } from 'Lib/Rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { actions } from '.';
import webApi from '../../../Lib/WebApi';
import { addErrorNotice, callApi, catchWithAuthErrors } from '../../Helpers/rxjsHelpers';
import { GetAction, InitAction, ListItemsGetResponseModel, ListOptionsGetResponseModel } from './types';

export const get: Epic = (action$) =>
  action$.pipe(
    ofType(actions.get.toString()),
    groupByKey(
      (action: GetAction) => action.payload.id,
      (group) =>
        group.pipe(
          debounceAllButFirst(DEBOUNCE_TIME_FOR_KEYSTROKE_IN_MS),
          switchMap((action: GetAction) => {
            const {
              payload: { id, params, endpoint },
            } = action;

            return callApi(webApi[endpoint].get(params)).pipe(
              map((response: ListItemsGetResponseModel) => {
                const {
                  Body: { Items },
                } = response;
                return actions.getResolve({
                  id,
                  items: Items.map((i) => ({
                    value: i.Value,
                    label: i.Label,
                    additionalProperties: i.AdditionalProperties ?? [],
                  })),
                });
              }),
              catchWithAuthErrors((err: any) =>
                of(actions.getReject({ id }), addErrorNotice('Retrieving list for dropdown options failed.', err))
              )
            );
          })
        )
    )
  );

export const init: Epic = (action$) =>
  action$.pipe(
    ofType(actions.init.toString()),
    switchMapByKey(
      (action: InitAction) => action.payload.id,
      (action: InitAction) => {
        const {
          payload: { id, params, endpoint },
        } = action;

        // Only qestlablists currently have an options endpoint as part of initialisation
        if (endpoint === '') {
          return [actions.initResolve({ id, options: undefined })];
        }

        return callApi(webApi[endpoint].get(params)).pipe(
          map((response: ListOptionsGetResponseModel) => {
            const {
              Body: { FreeEntry },
            } = response;
            return actions.initResolve({
              id,
              options: { freeEntry: FreeEntry },
            });
          }),
          catchWithAuthErrors((err: any) =>
            of(actions.initReject({ id }), addErrorNotice('Retrieving initial list options for dropdown failed.', err))
          )
        );
      }
    )
  );
